import { ACTUAL_DOMAIN } from './Domains';
import { matchesApex } from './HostUtils';
import { isTableRunHostname, TABLERUN_APEX_HOST } from './tablerun/hosts';

export const SHORT_URL_PATH = 's';

const E2E_DOMAIN = 'test.shef';
const LOCALHOST_DOMAIN = 'localhost';

/**
 * The cookie `domain` attribute for a request, derived from the host it arrived on.
 *
 * Derived per request rather than from a build-time env var because shef-web serves two apex
 * domains from one deploy. A `Domain=shef.com` cookie is silently rejected by the browser on
 * tablerun.com, which is what left device id, session, source and CCPA consent absent there.
 *
 * For a `devX.shef.com` environment this deliberately resolves to the shared `shef.com` apex, not
 * `devX.shef.com`: the API for that environment is `devX.api.shef.com` rather than
 * `api.devX.shef.com`, so scoping to the apex is the only way web and API cookies are shared per
 * environment.
 *
 * @param hostname - `req.get('Host')` on the server (may carry a port) or
 *   `window.location.hostname` in the browser.
 * @returns the apex to scope the cookie to; {@link ACTUAL_DOMAIN} for anything unrecognised, so
 *   an unexpected host degrades to today's behaviour rather than losing cookies entirely.
 */
export const cookieDomainForHost = (hostname?: string): string => {
  if (!hostname) {
    return ACTUAL_DOMAIN;
  }

  if (matchesApex(hostname, E2E_DOMAIN)) {
    return E2E_DOMAIN;
  }
  if (matchesApex(hostname, LOCALHOST_DOMAIN)) {
    return LOCALHOST_DOMAIN;
  }
  if (isTableRunHostname(hostname)) {
    return TABLERUN_APEX_HOST;
  }
  return ACTUAL_DOMAIN;
};
